<template>
  <div>
    <!-- Asset Information -->
    <div class="pa-2 mb-3">
      <div
        style="display: flex; justify-content: space-between"
        class="ma-3">
        <div>UUID</div>
        <div>{{ props.userEditObj?.uid }}</div>
      </div>
      <v-divider />
      <div
        style="display: flex; justify-content: space-between"
        class="ma-3">
        <div>Timestamp</div>
        <div>{{ formatTimestamp(props.userEditObj?.timestamp) }}</div>
      </div>
    </div>

    <!-- Stream Information -->
    <div
      class="pa-2 mb-3"
      v-for="(details, j) in streams"
      :key="(details, j)">
      <div
        v-if="streams.length > 1"
        style="
          display: flex;
          justify-content: center;
          opacity: 0.6;
          padding: 10px;
        ">
        Stream {{ j }}
      </div>
      <div
        v-for="(item, i) in details"
        :key="(item, i)">
        <div
          style="display: flex; justify-content: space-between"
          class="ma-3">
          <div>{{ item[0] }}</div>
          <div>{{ item[1] }}</div>
        </div>
        <v-divider v-if="i !== details.length - 1" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { $http } from '../../../stores/http';
const props = defineProps(['userEditObj']);

onMounted(() => {
  get_asset_info();
});
const streams = ref([]);
const selected_json = ref([]);

function formatTimestamp(timestamp) {
  if (!timestamp) return 'N/A';

  try {
    const date = new Date(timestamp);
    // Check if the date is valid
    if (isNaN(date.getTime())) return timestamp;
    const options = {
      day: 'numeric', // e.g., 10
      month: 'long', // e.g., June
      year: 'numeric', // e.g., 2025
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short', // e.g., BST
    };
    // detect locale automatically
    const locale = navigator.language || 'en-GB';
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return timestamp;
  }
}

async function get_asset_info() {
  try {
    const response = await $http(
      'GET',
      '/get_metadata_live?uid=' + props.userEditObj.uid
    );
    selected_json.value = JSON.parse(response)['streams'];
    for (var stream of selected_json.value) {
      var details = [];
      var is_image = false;
      const imageCodecs = ['mjpeg', 'png', 'bmp', 'tiff', 'webp'];
      if (imageCodecs.includes(stream.codec_name)) {
        is_image = true;
        details.push(['Type', 'Image']);
      }
      if (stream.codec_type && !is_image) {
        details.push(['Type', stream.codec_type]);
      }
      if (stream.codec_long_name) {
        details.push(['Codec', stream.codec_long_name]);
      }
      if (stream.profile) {
        details.push(['Profile', stream.profile]);
      }
      if (stream.width) {
        details.push(['Width', stream.width]);
      }
      if (stream.height) {
        details.push(['Height', stream.height]);
      }

      if (!is_image) {
        if (stream.avg_frame_rate) {
          details.push(['Framerate', stream.avg_frame_rate]);
        }
        if (stream.duration) {
          details.push(['Duration', stream.duration]);
        }
      }
      if (stream.color_space) {
        details.push(['Color Space', stream.color_space]);
      }
      if (stream.pix_fmt) {
        details.push(['Pixel Format', stream.pix_fmt]);
      }
      streams.value.push(details);
    }
  } catch (error) {
    console.log(error);
  }
}
</script>
